const InputTypes = {
    STRING: 'STRING',
    INTEGER: 'INTEGER',
    FLOAT: 'FLOAT',
    DOUBLE: 'DOUBLE',
    BOOLEAN: 'BOOLEAN',
    DATE: 'DATE',
    DATETIME: 'DATETIME',
    FILE: 'FILE',
    ARRAY: 'ARRAY',
    ENTITY: 'ENTITY',
};

export default InputTypes;
